"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Map_js_1 = __importDefault(require("ol/Map.js"));
const OSM_js_1 = __importDefault(require("ol/source/OSM.js"));
const Tile_js_1 = __importDefault(require("ol/layer/Tile.js"));
const View_js_1 = __importDefault(require("ol/View.js"));
const Vector_js_1 = __importDefault(require("ol/layer/Vector.js"));
const Vector_js_2 = __importDefault(require("ol/source/Vector.js"));
const Feature_1 = __importDefault(require("ol/Feature"));
const Overlay_1 = __importDefault(require("ol/Overlay"));
const style_1 = require("ol/style");
const format_1 = require("ol/format");
const geom_1 = require("ol/geom");
const proj_1 = require("ol/proj");
const BingMaps_js_1 = __importDefault(require("ol/source/BingMaps.js"));
const GeoTIFF_js_1 = __importDefault(require("ol/source/GeoTIFF.js"));
const WebGLTile_js_1 = __importDefault(require("ol/layer/WebGLTile.js"));
const LineString_js_1 = __importDefault(require("ol/geom/LineString.js"));
const Download_1 = __importDefault(require("./Download"));
const Center_1 = __importDefault(require("./Center"));
class MapOlModel {
    constructor(config) {
        this.pointInfo = null;
        this.polygonInfo = null;
        this.highResolutionMap = null;
        this.map = null;
        this.maxZoom = 17;
        this.minZoom = 10;
        this.center = [-10018754.171394622, 4685281.0516434];
        this.hasSamples = true;
        this.previusUrlRaster = '';
        this.preColorPoint = '';
        this.layerIdMap = new Map();
        this.prePolygon = '';
        this.preColor = '';
        this.config = config;
    }
    createMap() {
        this.drawMap();
    }
    newRaster() {
        if (this.config.provider === 'BingMaps') {
            return new Tile_js_1.default({
                source: new BingMaps_js_1.default({
                    key: this.config.apikey,
                    imagerySet: 'AerialWithLabels',
                }),
            });
        }
        else if (this.config.provider === 'OpenStreetMaps') {
            return new Tile_js_1.default({
                source: new OSM_js_1.default(),
                preload: 10,
            });
        }
        else {
            throw new Error(`Not supported map provider: ${this.config.provider}`);
        }
    }
    async drawMap() {
        console.log(this.config);
        const mapContainer = document.getElementById(this.config.mapId);
        const popupPoint = document.getElementById(this.config.pointsConnectorId);
        const tooltipPoint = this.tooltipPoint(popupPoint);
        const raster = this.newRaster();
        const layersMap = [];
        layersMap.push(raster);
        this.onGeotiffLoaded();
        layersMap.push(this.highResolutionMap);
        if (this.config.polygons.length > 0 || this.config.multiPolygon.length > 0) {
            layersMap.push(this.includeNewPolygonInMap().vector);
        }
        if (this.config.points.length > 0) {
            layersMap.push(this.includeNewPointsInMap());
        }
        this.map = new Map_js_1.default({
            target: mapContainer,
            layers: layersMap,
            view: new View_js_1.default({
                zoom: this.config.centerMapConfig.zoom,
                center: (0, proj_1.fromLonLat)(this.config.centerMapConfig.center),
                maxZoom: 16,
                minZoom: 8,
                preload: 0,
                extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
            }),
        });
        this.map.addOverlay(tooltipPoint);
        this.applyHoverStylePoint(this.map);
        this.deployTooltipPoint(this.map, tooltipPoint);
        if (this.config.tiffUrl) {
            this.onGeotiffLoaded();
        }
        this.hideControls();
    }
    isSamplesView(isSamples) {
        this.hasSamples = isSamples;
        const layerId = 'vector_point';
        const layer = this.layerIdMap.get(layerId);
        if (isSamples) {
            layer.setVisible(false);
            const elements = document.getElementById(this.config.pointsConnectorId);
            elements.style.display = 'none';
        }
        else {
            layer.setVisible(true);
        }
    }
    async resetMap() {
        if ((0, proj_1.fromLonLat)(this.config.centerMapConfig.center) !==
            this.map.getView().getCenter() &&
            this.config.multiPolygon.length < 1 &&
            this.config.points.length < 1 &&
            this.config.polygons.length < 1) {
            this.map.getView().setCenter((0, proj_1.fromLonLat)(this.config.centerMapConfig.center));
        }
        if (this.map) {
            this.resetColor();
            this.onGeotiffLoaded();
            this.includeNewPolygonInMap();
            this.includeNewPointsInMap();
            this.isSamplesView(this.hasSamples);
        }
    }
    resetColor() {
        if (this.preColor !== this.config.polygonStyle.fill) {
            const layers = this.map.getLayers();
            layers.forEach((layer) => {
                if (layer instanceof Vector_js_1.default &&
                    layer.get('id') === 'vector_polygon') {
                    const source = layer.getSource();
                    const features = source.getFeatures();
                    const newStyle = new style_1.Style({
                        fill: new style_1.Fill({
                            color: this.config.polygonStyle.fill,
                        }),
                        stroke: new style_1.Stroke({
                            color: this.config.polygonStyle.stroke,
                            width: 8,
                        }),
                    });
                    features.forEach((feature) => {
                        feature.setStyle(newStyle);
                    });
                }
            });
            this.preColor = this.config.polygonStyle.fill;
        }
    }
    onGeotiffLoaded() {
        let isVisible = false;
        if (!this.highResolutionMap) {
            let source;
            if (this.config.tiffUrl) {
                source = new GeoTIFF_js_1.default({
                    sources: [
                        {
                            url: this.config.tiffUrl,
                            nodata: 255,
                            max: 100,
                            min: 0,
                        },
                    ],
                });
                isVisible = true;
            }
            else {
                source = new Vector_js_2.default();
                isVisible = false;
            }
            const layer = new WebGLTile_js_1.default({
                source: source,
                visible: isVisible,
                style: {
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        this.config.rasterColors[0],
                        0.000001,
                        this.config.rasterColors[1],
                        0.2,
                        this.config.rasterColors[2],
                        0.4,
                        this.config.rasterColors[3],
                        0.6,
                        this.config.rasterColors[4],
                        0.8,
                        this.config.rasterColors[5],
                        1,
                        this.config.rasterColors[6],
                    ],
                },
            });
            this.highResolutionMap = layer;
        }
        if (this.config.tiffUrl && this.previusUrlRaster !== this.config.tiffUrl) {
            const source = new GeoTIFF_js_1.default({
                sources: [
                    {
                        url: this.config.tiffUrl,
                        nodata: 255,
                        max: 100,
                        min: 0,
                    },
                ],
            });
            this.highResolutionMap.setSource(source);
            this.highResolutionMap.setVisible(true);
        }
        else if (!this.config.tiffUrl) {
            this.highResolutionMap.setVisible(false);
        }
    }
    tooltipPoint(popupElement) {
        const popup = new Overlay_1.default({
            element: popupElement,
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -10],
        });
        return popup;
    }
    deployTooltipPoint(map, popup) {
        map.on('click', (event) => {
            const feature = map.forEachFeatureAtPixel(event.pixel, (feature) => feature);
            const popupElement = popup.getElement();
            const isInsidePopup = popupElement && popupElement.contains(event.originalEvent.target);
            if (isInsidePopup) {
                return;
            }
            if (feature && feature.getGeometry() instanceof geom_1.Point) {
                const coordinates = feature.getGeometry().getCoordinates();
                if (coordinates) {
                    popup.setPosition(coordinates);
                }
                this.pointInfo = feature.get('pointInfo');
                const button = document.getElementById(this.config.tooltipPointButtonId);
                const elements = document.getElementById(this.config.pointsConnectorId);
                elements.style.display = 'block';
                if (button) {
                    button.click();
                }
            }
            else {
                popup.setPosition(undefined);
            }
        });
    }
    generateColor(value) {
        if (value === 0)
            return this.config.rasterColors[0];
        else if (value === 1)
            return this.config.rasterColors[1];
        else if (value === 2)
            return this.config.rasterColors[2];
        else if (value === 3)
            return this.config.rasterColors[3];
        else if (value === 4)
            return this.config.rasterColors[4];
        else if (value === 5)
            return this.config.rasterColors[5];
        return this.config.rasterColors[0];
    }
    pointsStyles(point) {
        var _a;
        const iconWithShadow = new style_1.Icon({
            anchor: [20, 20],
            scale: 1,
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            src: point.iconUrl || this.config.imgDefaultPoint,
            rotation: 0,
            color: this.generateColor((_a = point.info) === null || _a === void 0 ? void 0 : _a.level),
        });
        const pointStyle = new style_1.Style({
            image: iconWithShadow,
        });
        const defaultStyles = [pointStyle];
        this.pointDefaultStyle = defaultStyles;
        return {
            defaultStyles: defaultStyles,
        };
    }
    applyHoverStylePoint(map) {
        let previousFeature = null;
        let previousStyle;
        map.on('pointermove', (event) => {
            const pixel = event.pixel;
            const feature = map.forEachFeatureAtPixel(pixel, (feature) => feature);
            if (feature && feature.getGeometry() instanceof geom_1.Point) {
                map.getTargetElement().style.cursor = 'pointer';
                if (previousFeature && previousFeature !== feature) {
                    previousFeature.setStyle(previousStyle);
                }
                const style = feature.getStyle();
                previousStyle = style;
                if (feature !== previousFeature) {
                    previousFeature = feature;
                }
                if (style) {
                    const circleStyle = style[0].getImage();
                    if (circleStyle && circleStyle.getScale() <= 1.1) {
                        circleStyle.setScale(1.1);
                    }
                    feature.setStyle(style);
                }
            }
            else if (previousFeature) {
                previousFeature.setStyle(previousStyle);
                const circleStyle = previousStyle[0].getImage();
                if (circleStyle) {
                    // Restaurar la escala del círculo con transición suave
                    circleStyle.setScale(1);
                }
                previousFeature = null;
                previousStyle = null;
                map.getTargetElement().style.cursor = '';
            }
        });
    }
    includeNewPointsInMap() {
        const points = this.config.points;
        const vectorSource = new Vector_js_2.default();
        const vectorLayer = new Vector_js_1.default({
            source: vectorSource,
            id: 'vector_point',
        });
        const usedCoordinates = new Set();
        points.forEach((point) => {
            const coordinates = point.coordinates.split(' ');
            const lon = parseFloat(coordinates[0].substring(6));
            const lat = parseFloat(coordinates[1].slice(0, -1));
            let newLon = lon;
            let newLat = lat;
            const originalCoordinateKey = `${lon}-${lat}`;
            if (usedCoordinates.has(originalCoordinateKey)) {
                const randomOffset = 0.0005;
                newLon = lon + 0.3 * randomOffset;
                newLat = lat - 0.3 * randomOffset;
            }
            const feature = new Feature_1.default({
                geometry: new geom_1.Point((0, proj_1.fromLonLat)([newLon, newLat])),
                pointInfo: point.info,
            });
            feature.setStyle(this.pointsStyles(point).defaultStyles);
            vectorSource.addFeature(feature);
            usedCoordinates.add(`${newLon}-${newLat}`);
        });
        const layerIdToRemove = 'vector_point';
        const layerToRemove = this.layerIdMap.get(layerIdToRemove);
        if (layerToRemove) {
            this.map.removeLayer(layerToRemove);
            this.layerIdMap.delete(layerIdToRemove);
        }
        this.map.addLayer(vectorLayer);
        this.layerIdMap.set('vector_point', vectorLayer);
        return vectorLayer;
    }
    deleteMapLayer(layer, idLayer, time) {
        this.map.getLayers().forEach((existingLayer) => {
            const layerId = idLayer;
            if (layerId === 'vector_polygon' && existingLayer === layer) {
                setTimeout(() => {
                    this.map.removeLayer(existingLayer);
                }, time);
            }
        });
    }
    includeMapLayer(layer, newIdLayer) {
        this.map.addLayer(layer);
        this.layerIdMap.set(newIdLayer, layer);
    }
    includeNewPolygonInMap() {
        let vector;
        if (this.prePolygon !== this.config.multiPolygon) {
            const elements = document.getElementById(this.config.pointsConnectorId);
            elements.style.display = 'none';
            const format = new format_1.WKT();
            const features = [];
            const feature = format.readFeature(this.config.multiPolygon, {
                dataProjection: this.config.projection.dataProjection,
                featureProjection: this.config.projection.featureProjection,
            });
            const styles = this.polygonStyles(this.config.polygonStyle);
            feature.setStyle(styles);
            features.push(feature);
            vector = new Vector_js_1.default({
                source: new Vector_js_2.default({
                    features: features,
                }),
                id: 'vector_polygon',
            });
            const layerIdToRemove = 'vector_polygon';
            const layerToRemove = this.layerIdMap.get(layerIdToRemove);
            this.focus();
            this.includeMapLayer(vector, 'vector_polygon');
            let center1;
            if (layerToRemove) {
                const extent1 = layerToRemove.getSource().getExtent();
                const centerX1 = (extent1[0] + extent1[2]) / 2;
                const centerY1 = (extent1[1] + extent1[3]) / 2;
                center1 = [centerX1, centerY1];
            }
            else {
                center1 = [-20037508.34, -20037508.34, 20037508.34, 20037508.34];
            }
            const extent2 = vector.getSource().getExtent();
            const centerX2 = (extent2[0] + extent2[2]) / 2;
            const centerY2 = (extent2[1] + extent2[3]) / 2;
            const center2 = [centerX2, centerY2];
            const distance = this.distanceBetweenPoints(center1, center2);
            if (layerToRemove !== vector) {
                if (distance > 15000) {
                    this.deleteMapLayer(layerToRemove, layerIdToRemove, 5000);
                }
                else {
                    this.deleteMapLayer(layerToRemove, layerIdToRemove, 0);
                }
                this.focus();
                this.prePolygon = this.config.multiPolygon;
            }
        }
        return { vector: vector };
    }
    polygonStyles(styles) {
        var _a;
        const { stroke, fill, strokeWidth } = styles;
        const strokeStyle = new style_1.Stroke({
            color: stroke || '',
            width: strokeWidth,
        });
        const strokeStyleHover = new style_1.Stroke({
            color: stroke || '',
            width: 10,
        });
        let fillCurrent = '';
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.tiffUrl) {
            fillCurrent = [0, 0, 0, 0];
        }
        else {
            fillCurrent = fill;
        }
        const fillStyle = new style_1.Fill({
            color: fillCurrent || '',
        });
        const polygonStyle = new style_1.Style({
            stroke: strokeStyle,
            fill: fillStyle,
        });
        const polygonStyleHover = new style_1.Style({
            stroke: strokeStyleHover,
            fill: fillStyle,
        });
        this.polygonDefaultStyle = polygonStyle;
        this.polygonHoverStyle = polygonStyleHover;
        return polygonStyle;
    }
    distanceBetweenPoints(latlng1, latlng2) {
        const line = new LineString_js_1.default([latlng1, latlng2]);
        return Math.round(line.getLength() * 100) / 100;
    }
    hideControls() {
        const controls = this.map.getControls();
        controls.forEach((control) => {
            control.setMap(null);
        });
    }
    zoomIn() {
        const currentZoom = this.map.getView().getZoom();
        const maxZoom = this.map.getView().getMaxZoom();
        if (currentZoom < maxZoom) {
            this.map.getView().setZoom(currentZoom + 1);
        }
    }
    zoomOut() {
        const currentZoom = this.map.getView().getZoom();
        const minZoom = this.map.getView().getMinZoom();
        if (currentZoom > minZoom) {
            this.map.getView().setZoom(currentZoom - 1);
        }
    }
    fullScreen() {
        const mapContainer = document.getElementById(this.config.mapId);
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
        else {
            mapContainer.requestFullscreen();
        }
    }
    focus() {
        const config = {
            map: this.map,
            projection: this.config.projection,
            multiPolygon: this.config.multiPolygon,
        };
        const model = new Center_1.default(config);
        model.center();
        this.map = model.map;
    }
    download(typeFile) {
        const config = {
            map: this.map,
            parcelName: this.config.parcelName,
            projection: this.config.projection,
            pointVectorLayer: this.includeNewPointsInMap(),
            polygonVectorLayer: this.includeNewPolygonInMap().vector,
        };
        const model = new Download_1.default(config);
        model.download(typeFile);
    }
    async softZomm(extent, map) {
        const MapView = map.getView();
        const resolution = MapView.getResolutionForExtent(extent);
        const zoom = MapView.getZoomForResolution(resolution);
        MapView.animate({
            zoom: zoom - 0.5,
            center: getCenter(extent),
            duration: 1000,
            maxZoom: 16,
            minZoom: 10,
        }, () => {
            const currentZoom = MapView.getZoom();
            const currentCenter = MapView.getCenter();
            const currentExtent = MapView.calculateExtent();
            const bufferDistanceInMeters = 2500;
            const bufferInMapProjection = buffer(currentExtent, bufferDistanceInMeters);
            const newView = new View_js_1.default({
                zoom: currentZoom,
                maxZoom: currentZoom + 1,
                minZoom: currentZoom - 1,
                center: currentCenter,
                extent: bufferInMapProjection,
            });
            map.setView(newView);
        });
    }
    flyTo(extent, map) {
        const MapView = map.getView();
        const mapZoom = MapView.getZoom();
        const resolution = MapView.getResolutionForExtent(extent);
        const zoom = MapView.getZoomForResolution(resolution);
        MapView.animate({
            zoom: mapZoom - 2,
            duration: 2000,
        });
        setTimeout(() => {
            MapView.animate({
                zoom: zoom - 2,
                center: getCenter(extent),
                duration: 1000,
            });
        }, 2100);
        setTimeout(() => {
            MapView.animate({
                zoom: zoom - 0.5,
                duration: 1000,
            }, () => {
                const currentZoom = MapView.getZoom();
                const currentCenter = MapView.getCenter();
                const currentExtent = MapView.calculateExtent();
                const bufferDistanceInMeters = 2500;
                const bufferInMapProjection = buffer(currentExtent, bufferDistanceInMeters);
                const newView = new View_js_1.default({
                    zoom: currentZoom,
                    maxZoom: currentZoom + 1,
                    minZoom: currentZoom - 1,
                    center: currentCenter,
                    extent: bufferInMapProjection,
                });
                map.setView(newView);
            });
        }, 3500);
    }
    fitMapCenter(extent) {
        if (JSON.stringify(this.oldExtent) !== JSON.stringify(extent)) {
            const map = this.map;
            const location = getCenter(extent);
            const view = this.map.getView();
            const center = view.getCenter();
            const distance = this.distanceBetweenPoints(location, center);
            const newView = new View_js_1.default({
                zoom: view.getZoom(),
                maxZoom: 18,
                minZoom: 0,
                center: center,
                extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
            });
            map.setView(newView);
            if (distance > 15000 && this.oldExtent) {
                this.flyTo(extent, map);
            }
            else {
                this.softZomm(extent, map);
            }
            this.oldExtent = extent;
        }
    }
    centerOnPolygon(geometry) {
        this.geometryPolygonCenter = geometry;
        const extent = geometry.getExtent();
        this.fitMapCenter(extent);
    }
    centerOnMultipleGeometries(geometries) {
        const geometryCollection = new GeometryCollection(geometries);
        const extent = geometryCollection.getExtent();
        this.fitMapCenter(extent);
    }
    get allFeatures() {
        const pointVectorLayer = this.vectorPoints();
        const pointVectorSource = pointVectorLayer.getSource();
        const pointFeatures = pointVectorSource.getFeatures();
        const polygonVectorLayer = this.vectorPolygon().vector;
        const polygonVectorSource = polygonVectorLayer.getSource();
        const polygonFeatures = polygonVectorSource.getFeatures();
        const allFeatures = pointFeatures.concat(polygonFeatures);
        return allFeatures;
    }
    downloadPNG() {
        this.map.getRenderer().renderFrame();
        const mapElement = this.map.getTargetElement();
        const canvasElement = mapElement.querySelector('canvas');
        const dataURL = canvasElement.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${this.config.parcelName}.png`;
        link.click();
        this.centerMap();
    }
    downloadKML() {
        const text = new KML().writeFeatures(this.allFeatures, {
            featureProjection: this.config.projection.featureProjection,
            dataProjection: this.config.projection.dataProjection,
        });
        this.downloadFile(text, `${this.config.parcelName}.kml`);
    }
    downloadJSON() {
        const text = new GeoJSON().writeFeatures(this.allFeatures, {
            featureProjection: this.config.projection.featureProjection,
            dataProjection: this.config.projection.dataProjection,
        });
        this.downloadFile(text, `${this.config.parcelName}.json`);
    }
    downloadKMZ() {
        const kmlFormat = new KML();
        const kmz = new JSZip();
        const kmlText = kmlFormat.writeFeatures(this.allFeatures, {
            featureProjection: this.config.projection.featureProjection,
            dataProjection: this.config.projection.dataProjection,
        });
        kmz.file(`${this.config.parcelName}.kml`, kmlText);
        kmz.generateAsync({ type: 'blob' }).then((content) => {
            this.downloadFile(content, `${this.config.parcelName}.kmz`);
        });
    }
    downloadFile(data, filename) {
        const blob = new Blob([data], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
    download(type) {
        if (type === '.png') {
            this.downloadPNG();
        }
        else if (type === '.kml') {
            this.downloadKML();
        }
        else if (type === '.kmz') {
            this.downloadKMZ();
        }
        else if (type === '.geojson') {
            this.downloadJSON();
        }
    }
}
exports.default = MapOlModel;
